const sitAdmins = [
    {
        userId: "auth0|6056a9496f13340069217f46",
        orgId: "test-org-id1",
        emails: ["jason@adadot.com"],
    },
];

const prodAdmins = [
    {
        userId: "auth0|62b2e738836975d34ffd2d5c",
        orgId: "44cd606e-c0b8-4140-9ba2-435c1a8333b9",
        emails: ["jason@adadot.com"],
    },
    {
        userId: "auth0|62adce105ced59820ca4e8e7",
        orgId: "44cd606e-c0b8-4140-9ba2-435c1a8333b9",
        emails: ["alex.harris@adadot.com"],
    },
    {
        userId: "auth0|62979bbf7baefb006ec480e7",
        orgId: "44cd606e-c0b8-4140-9ba2-435c1a8333b9",
        emails: ["o.panagou+omgwereatprod@adadot.com"],
    },
    {
        userId: "auth0|61fc163c91ad9a006b2f5a7a",
        orgId: "44cd606e-c0b8-4140-9ba2-435c1a8333b9",
        emails: ["d.soras@adadot.com"],
    },
    {
        userId: "google-oauth2|113642497728551248293",
        orgId: "44cd606e-c0b8-4140-9ba2-435c1a8333b9",
        emails: ["j.clark@adadot.com"],
    },
];

const admins = [...sitAdmins, ...prodAdmins];

export default admins;
